export default __webpack_public_path__ + "static/media/gabriela-wajnerman-decorate-review.a98103a8.jpg";